import { ADD_PLAN, ADD_PLAN_FAILED, ADD_PLAN_SUCCESSFUL, API_ERROR, RESET_PAY_INFO, RESET_RESPONSE_MESSAGE } from "./actionTypes"


export const addPlan = (plan, history) => {
  return {
    type: ADD_PLAN,
    payload: { plan, history },
  }
}

export const addPlanSuccessful = plan => {
  return {
    type: ADD_PLAN_SUCCESSFUL,
    payload: plan,
  }
}

export const addPlanFailed = plan => {
  return {
    type: ADD_PLAN_FAILED,
    payload: plan,
  }
}
export const resetPlanPayInfo = () => {
  return {
    type: RESET_PAY_INFO,

  }
}

export const apiErrorPlanAct = () => {
  return {
    type: API_ERROR,
  }
}
export const resetPlanResponse = () => {
  return {
    type: RESET_RESPONSE_MESSAGE,
  }
}